import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"text-decoration-none",attrs:{"to":"/"}},[_c(VToolbarTitle,{staticClass:"ml-2",class:_vm.color},[_c('b',[_vm._v(_vm._s(_vm.getLogo.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }